var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ff1414",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 0.6
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M89.307,12.5h-0.005V8.48c0-0.956-0.774-1.73-1.73-1.73h-2.45v0H56.431v0h-1.73L28.752,32.7v2.447v1.013v1.777h0.014 c0.073,0.888,0.809,1.588,1.716,1.588h6.49h0c0.907,0,1.642-0.7,1.716-1.588h0.021V36.16h17.723c0.956,0,1.73-0.774,1.73-1.73 V16.707H79.35l0,66.587H38.708v-3.012h-0.007c-0.001-0.954-0.775-1.728-1.73-1.728h-6.49h0c-0.955,0-1.729,0.773-1.73,1.728h0 v8.792v2.447c0,0.956,0.774,1.73,1.73,1.73h1.582h53.925h1.582c0.956,0,1.73-0.774,1.73-1.73v-2.448h0.005L89.307,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6,59.04c0-8.847-7.169-16.021-16.02-16.021c-8.851,0-16.02,7.174-16.02,16.021c0,2.99,0.834,5.78,2.26,8.175 l-7.815,7.815l0.031,0.031c-0.831,0.795-1.344,1.919-1.344,3.194c0,2.463,1.962,4.39,4.423,4.39c1.257,0,2.379-0.506,3.181-1.324 l0.022,0.022l8.024-8.024c2.176,1.105,4.63,1.741,7.238,1.741C42.431,75.059,49.6,67.887,49.6,59.04z M24.282,59.039 c0-5.135,4.162-9.298,9.299-9.298c5.137,0,9.298,4.163,9.298,9.298c0,5.136-4.161,9.299-9.298,9.299 C28.443,68.338,24.282,64.175,24.282,59.039z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestOff);
export default __webpack_public_path__ + "static/media/test_off.855d4343d9997fbdfd4a60b4cc6cc8e0.svg";
export { ForwardRef as ReactComponent };